import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getDynamicLink({ commit }, params) {
    return GraphQlClient.query(`
      query (
        $integrationKey: String!,
        $username: String!,
        $path: String!,
      ) {
        DynamicLink(
          integrationKey: $integrationKey,
          username: $username,
          path: $path,
        ) {
          url
        }
      }
    `, params)
      .then(({ data = {} }) => {
        const { DynamicLink } = data || {};
        const { url } = DynamicLink || {};

        return Promise.resolve(url);
      });
  },
};



// WEBPACK FOOTER //
// ./src/stores/integrations/actions.js